/**
 * Definição dos tokens para a mascara.
 * Os seguintes tokens representam:
 * - #: números;
 * - S: texto;
 * - A: texto e números;
 * - U: maísculas;
 * - L: minisculas;
 * - H: primeiro digito da hora;
 * - h: segundo digito da hora;
 * - M: primeiro digito dos minutos;
 * - m: segundo digito do minutos;
 *
*/
const tokens = {
    '#': { pattern: /\d/ }, // números
    S: { pattern: /[a-zA-Z]/ }, // strings
    A: { pattern: /[0-9a-zA-Z]/ }, // string e números
    U: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
    L: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
    H: { pattern: /[0-2]/ },
    h: { pattern: /[0-4]/ },
    M: { pattern: /[0-5]/ },
    m: { pattern: /[0-9]/ }
};

/**
 * Aplicação da máscara a input.
 *
 * @param {String} value
 * @param {String} mask
 * @param {Boolean} masked
 * @return {String}
 * @since 1.1.0
 * @author Tiago Martinho
 *
*/
const applyMask = ( value = '', mask, masked = true ) => {
    let maskIndex = 0;
    let valueIndex = 0;
    let output = '';

    while ( maskIndex < mask.length && valueIndex < value.length ) {
        const maskChar = mask[maskIndex];
        const masker = tokens[maskChar];
        const valueChar = value[valueIndex];

        if ( masker ) {
            if ( masker.pattern.test( valueChar ) ) {
                output += !masker.transform ? valueChar : masker.transform( valueChar );
                maskIndex++;
            }

            valueIndex++;
        } else {
            if ( masked )
                output += maskChar;

            if ( valueChar.toLocaleLowerCase() === maskChar.toLocaleLowerCase() )
                valueIndex++;

            maskIndex++;
        }
    }

    return output;
};

export default applyMask;